export default "__VITE_ASSET__CMM70u_Y__"